import { shallowRef } from 'vue'
import { documentAgreementLogs } from '@/requests/documentAgreement'
import { DocumentAgreementLog } from '@/utils/types/documentAgreement'
import { handleAsync } from 'best-modules/plugins'
import { openDialog } from '@/dialog'
import { DocumentAgreementContext } from '../types'

export function useLogs(context: DocumentAgreementContext) {
  const { documentAgreementId, documentAgreementSource } = context
  const logs = shallowRef<DocumentAgreementLog[]>([])

  const getLogs = () => {
    return handleAsync('getLogs', () => {
      return documentAgreementLogs(documentAgreementId.value).then(res => {
        logs.value = res
      })
    })
  }

  const openLogsDialog = () => {
    openDialog({
      name: 'DocumentAgreementHistory',
      dialogData: {
        documentAgreementId: documentAgreementId.value,
        name: documentAgreementSource.name,
      },
      params: { hideActionButtons: true },
    })
  }

  return { logs, getLogs, openLogsDialog }
}
